import {
  UsuarioPerfil,
  usuarioPerfilAdministrador,
  usuarioPerfilAtendente,
  usuarioPerfilFinanceiro,
  usuarioPerfilGerente,
  usuarioPerfilRepresentante,
} from '../../../home/usuario/usuario-perfil';

export const acessosClienteRecompraReport: UsuarioPerfil[] = [usuarioPerfilAdministrador];

export const acessosMetaRepresentanteReport: UsuarioPerfil[] = [usuarioPerfilAdministrador];

export const acessosAtividadeReport: UsuarioPerfil[] = [
  usuarioPerfilAdministrador,
  usuarioPerfilGerente,
  usuarioPerfilAtendente,
  usuarioPerfilRepresentante,
  usuarioPerfilFinanceiro,
];

export const acessosAnaliseMercadoReport: UsuarioPerfil[] = [
  usuarioPerfilAdministrador,
  usuarioPerfilGerente,
  usuarioPerfilAtendente,
  usuarioPerfilRepresentante,
];

export const acessosMetaMercadoRealizadoReport: UsuarioPerfil[] = [
  usuarioPerfilAdministrador,
  usuarioPerfilAtendente,
];

export const acessosRelatorios: UsuarioPerfil[] = [
  ...new Map(
    [
      ...acessosClienteRecompraReport,
      ...acessosMetaRepresentanteReport,
      ...acessosAtividadeReport,
      ...acessosAnaliseMercadoReport,
      ...acessosMetaMercadoRealizadoReport,
    ].map((perfil) => [perfil.id, perfil])
  ).values(),
];
